<template>
  <div>
    <footer class="main-footer row mx-0 bg-wl-primary pt-5 px-3 p-lg-5">
      <div class="col-12 col-md-6 mx-auto">

        <div class="row">
          <div class="col-12 col-lg-6 d-flex justify-content-center justify-content-lg-start">
            <img src="@/assets/images/logo-powered.png" alt="Talentos na Pista Logotipo" style="height: 100px;">
          </div>

          <div class="col-12 col-lg-6 py-5">
            <p class="text-center">Redes Sociais</p>
            <div class="d-flex justify-content-center mx-auto">
              <a href="https://www.facebook.com/groups/frentistafrentistabr/" target="_blank" class="mx-2">
                <img src="@/assets/images/facebook-icon.png" style="height: 40px;">
              </a>
              <a href="https://www.instagram.com/postospetrobras/" target="_blank" class="mx-2">
                <img src="@/assets/images/instagram-icon.png" style="height: 40px;">
              </a>
              <a href="https://twitter.com/99jobs" target="_blank" class="mx-2">
                <img src="@/assets/images/twitter-icon.png" style="height: 40px;">
              </a>
              <a href="https://www.linkedin.com/company/99jobs" target="_blank" class="mx-2">
                <img src="@/assets/images/linkedin-icon.png" style="height: 40px;">
              </a>
              <a href="https://www.tiktok.com/@postospetrobras" target="_blank" class="mx-2">
                <img src="@/assets/images/tiktok-icon.png" style="height: 40px;">
              </a>
            </div>
          </div>
        </div>

      </div>
    </footer>
  </div>
</template>

<script>

export default {
  name: "MainFooter",

  computed: {
  },

  components: {
  },
};
</script>


<style lang="scss" scoped>
</style>